import React from 'react';
import PropTypes from 'prop-types';

import { Badge, Col, Row } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import TagPicker from './tag_picker';

export default function TaggingsList({ taggings, onAdd, onRemove }) {
  return (
    <Row className="gx-2 gy-2 align-items-center">
      {taggings.map(tagging => (
        <Col key={tagging.id} xs="auto">
          <Badge bg="" className="bg-connect-tag text-body">
            <small className="fw-normal">{tagging.name}</small>
            <FontAwesomeIcon
              className="ms-2 clickable fw-bolder"
              icon={faTimes}
              onClick={() => onRemove(tagging)}
            />
          </Badge>
        </Col>
      ))}
      <Col xs="auto">
        <TagPicker excludeNames={taggings.map(({ name }) => name)} onTagSelected={onAdd} />
      </Col>
    </Row>
  );
}

TaggingsList.propTypes = {
  taggings: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
